import base from './base.repository';
export default {
    ...base,
    getTools(){
        this.get(`tools`);
        return this;
    }
}